import React, { useState, useEffect, useRef, Component } from "react";
import { CSVLink, CSVDownload } from "react-csv";

var data;

export default class ExportToExcle extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    var headers;
    data = props;

    const invoiceBookId = props;
    console.log(invoiceBookId);
    if (invoiceBookId === 1 || invoiceBookId == 2 || invoiceBookId == 9) {
      headers = [
        { label: "Name Inoice", key: "invBookName" },
        { label: "Issue Date", key: "issueDate" },
        { label: "Invoice No", key: "invNo" },
        { label: "Name", key: "clientName" },
        { label: "Total", key: "total" },
        { label: "Sub Total", key: "subTotal" },
        { label: "Sale Tax", key: "saleTax" },
        { label: "Paid Amount", key: "amountPaid" },
        { label: "Due Amount", key: "amountDue" },
        { label: "PO No", key: "PO_No" },
        { label: "Due Date", key: "dueDate" },
        { label: "Notes", key: "Notes" },
        { label: "Home Currency Total", key: "HomeCurrTotal" },
        { label: "Home Currency Amount Paid", key: "HomeCurrAmountPaid" },
      ];
    } else if (invoiceBookId === 10) {
      headers = [
        { label: "Name Inoice", key: "invBookName" },
        { label: "Issue Date", key: "issueDate" },
        { label: "Invoice No", key: "invNo" },
        { label: "Name", key: "clientName" },
        { label: "Total", key: "total" },
      ];
    } else if (invoiceBookId === 6 || invoiceBookId == 7) {
      headers = [
        { label: "Name Inoice", key: "invBookName" },
        { label: "Issue Date", key: "issueDate" },
        { label: "Invoice No", key: "invNo" },
        { label: "Name", key: "clientName" },
        { label: "Total", key: "total" },
        { label: "Sub Total", key: "subTotal" },
        { label: "Sale Tax", key: "saleTax" },
        { label: "Paid Amount", key: "amountPaid" },
        { label: "Due Amount", key: "amountDue" },
        { label: "Ref No", key: "PO_No" },
        { label: "Due Date", key: "dueDate" },
        { label: "Notes", key: "Notes" },
        { label: "Home Currency Total", key: "HomeCurrTotal" },
        { label: "Home Currency Amount Paid", key: "HomeCurrAmountPaid" },
      ];
    } else if (invoiceBookId === 5) {
      headers = [
        { label: "Name Inoice", key: "invBookName" },
        { label: "Issue Date", key: "issueDate" },
        { label: "Invoice No", key: "invNo" },
        { label: "Name", key: "clientName" },
        { label: "Total", key: "total" },
      ];
    } else if (invoiceBookId === 22) {
      headers = [
        { label: "Name Inoice", key: "invBookName" },
        { label: "Issue Date", key: "issueDate" },
        { label: "Invoice No", key: "invNo" },
        { label: "Name", key: "clientName" },
        { label: "Total", key: "total" },
        { label: "Notes", key: "Notes" },
        { label: "Origin", key: "Origin" },
        { label: "Destination", key: "Destination" },
        { label: "Distance", key: "Distance" },
        { label: "Rate", key: "Rate" },
      ];
    } else if (invoiceBookId === 24) {
      headers = [
        { label: "Name Inoice", key: "invBookName" },
        { label: "Issue Date", key: "issueDate" },
        { label: "Invoice No", key: "invNo" },
        { label: "Supplier Name", key: "supplierName" },
        { label: "Employee Name", key: "empName" },
        { label: "Total", key: "total" },
      ];
    } else if (invoiceBookId === 25) {
      headers = [
        { label: "Name Inoice", key: "invBookName" },
        { label: "Issue Date", key: "issueDate" },
        { label: "Invoice No", key: "invNo" },
        { label: "Employee Name", key: "empName" },
        { label: "Total", key: "total" },
      ];
    }
    console.log(props, headers);
    this.state = {
      propData: props,
      headers: headers,
    };
  }
  componentDidMount() {
    console.log(this.myRef.current);
    this.myRef.current.props.onClick();
  }

  render() {
    return (
      <div>
        {console.log("props", this.props.Data)}
        {console.log("header", this.state?.headers)}
        {this.state?.propData ? (
          <CSVDownload
            target="_blank"
            asyncOnClick={true}
            data={this.props.Data}
            headers={this.state?.headers}
            filename="Bullet-Export-Complete.csv"
            ref={this.myRef}
            onClick={() => window.location.reload()}
            // onChange={this.myRef.current.onClick()}  className="btn btn-primary"
          >
            Export To Excel
          </CSVDownload>
        ) : null}
      </div>
    );
  }
}
